import * as React from 'react';
import { Link } from 'react-router-dom';
import Project from 'src/entities/Project';
import * as moment from 'moment';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';
import './MyProjects.css';
import ImageContainer from 'src/modules/commons/images/Image.container';

interface Props {
  project: Project;
}

class MyProjectCardComponent extends React.PureComponent<Props> {

  public render(): React.ReactNode {

    const premoneyValuation = NumberFormater.euros(this.props.project.premoneyValuation, 0);
    const cashTarget = NumberFormater.euros(Math.round(this.props.project.cashTarget), 0);
    const cash = NumberFormater.euros(Math.round(this.props.project.cash), 0);

    return (
      <section>
        <div className="col-md-6">
          <div className="my-projects-card">
              <div className="simple-card">
                <div className="col-xs-6 border-right">
                  <p className="deco-title">
                    <ImageContainer
                      alt={this.props.project.company.name + ' logo'}
                      className="img-responsive text-left"
                      url={this.props.project.company.logo}
                    />
                  </p>
                  <p>
                    Inicio de la ronda: {moment.utc(this.props.project.startDate).format('DD/MM/YYYY')}
                  </p>
                  {this.renderProjectStatusBadge()}
                  <div className="gap-10"/>
                  <div className="row">
                    <div className="col-xs-3">
                      <p>
                        Capital<br/>
                        invertido:
                      </p>
                    </div>
                    <div className="col-xs-9">
                      <p className="lead c-black-text text-center force-down-5 f-s-26 primary-font">
                        <strong>{cash}</strong>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xs-6">
                  <div className="gap-10"/>
                  <p className="icon-content">
                    <img alt="Euro" className="icon" src="/img/euro.png"/>
                    <span className="inline-block">
                    Valoración pre-money:
                    <br/>
                    <strong>
                      {premoneyValuation}
                      </strong>
                  </span>
                  </p>
                  <div className="gap-10"/>
                  <p className="icon-content">
                    <img alt="Importe" className="icon" src="/img/money.png"/>
                    <span className="inline-block">
                    Importe de la ronda:
                    <br/>
                    <strong>
                      {cashTarget}
                    </strong>
                  </span>
                  </p>
                  <div className="gap-10"/>
                  <p className="icon-content">
                    <img alt="Equity" className="icon" src="/img/equity.png"/>
                    <span className="inline-block">
                    Porcentaje de equity:
                    <br/>
                    <strong>
                      {this.props.project.equity.toLocaleString('es') + ' %'}
                    </strong>
                  </span>
                  </p>
                </div>
              </div>
            <p className="text-right">
              <Link to={'/mi-empresa/editar/' + this.props.project.id} className="btn btn-primary margin-r-10">
                Editar
              </Link>
              <Link to={'/ficha-de-operaciones/' + this.props.project.id} className="btn btn-secondary">
                Ver operación
              </Link>
            </p>
            <div className="gap-20"/>
          </div>
        </div>
      </section>
    );
  }

  private renderProjectStatusBadge(): React.ReactNode {
    switch (this.props.project.status) {
      case 'En construcción':
        return (
          <p>
            <span className="badge margin-r-10"/>
            <strong>{this.props.project.status}</strong>
          </p>
        );
      case 'Pendiente de revisión':
        return (
          <p>
            <span className="badge badge-yellow margin-r-10"/>
            <strong>{this.props.project.status}</strong>
          </p>
        );
      case 'Aprobado':
        return (
          <p>
            <span className="badge badge-green margin-r-10"/>
            <strong>{this.props.project.status}</strong>
          </p>
        );
      case 'En financiación':
        return (
          <p>
            <span className="badge badge-primary margin-r-10"/>
            <strong>{this.props.project.status}</strong>
          </p>
        );
      case 'Realizando Due Diligence':
        return (
          <p>
            <span className="badge badge-blue margin-r-10"/>
            <strong className="c-blue">{this.props.project.status}</strong>
          </p>
        );
      case 'Formalizando operación':
        return (
          <p>
            <span className="badge badge-blue-dark margin-r-10"/>
            <strong className="c-blue-dark">{this.props.project.status}</strong>
          </p>
        );
      case 'Financiación con éxito':
        return (
          <p>
            <span className="check margin-r-10"/>
            <strong className="c-primary">{this.props.project.status}</strong>
          </p>
        );
      case 'Financiación inalcanzada':
        return (
          <p>
            <span className="close-orange close-orange-med margin-r-10"/>
            <strong className="c-orange-dark">{this.props.project.status}</strong>
          </p>
        );
      case 'Due Diligence no superada':
        return (
          <p>
            <span className="close-orange close-orange-med margin-r-10"/>
            <strong className="c-orange-dark">{this.props.project.status}</strong>
          </p>
        );
      case 'Formalización fallida':
        return (
          <p>
            <span className="close-orange close-orange-med margin-r-10"/>
            <strong className="c-orange-dark">{this.props.project.status}</strong>
          </p>
        );
      default:
        return null;
    }
  }
}

export default MyProjectCardComponent;


// WEBPACK FOOTER //
// ./src/modules/projects/my-projects/partials/MyProjectCard.component.tsx